import '@/assets/styles/global.scss';
import { message } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import isBetween from 'dayjs/plugin/isBetween';
import '../tailwind.css';
import { openUpdateVersionNotify } from './tools/fetchUpdateVersionFile';

dayjs.locale('zh-cn');
dayjs.extend(isBetween);
message.config({
  maxCount: 1,
});
/**
 * 清理筛选项配置的历史遗留缓存。
 * 早期 SearchSort 没有按页面区分，所有搜索栏的筛选项配置共用 'cacheKey' 这一个 key，
 * 现已改为 `SEARCH_SORT_${路由 path}`，这里把旧数据删掉，避免长期残留在用户浏览器里。
 * TODO: 上线一段时间后可移除本段。
 */
localStorage.removeItem('cacheKey');

const { NODE_ENV } = process.env;
console.log(NODE_ENV);
if (NODE_ENV !== 'development') {
  openUpdateVersionNotify();
}
